// API related actions
export const FETCHING_VEHICLE_CHASSIS = '@@toyota/FETCHING_VEHICLE_CHASSIS';
export const FETCHED_VEHICLE_CHASSIS = '@@toyota/FETCHED_VEHICLE_CHASSIS';
export const FETCHED_VEHICLE_CHASSIS_FAILED = '@@toyota/FETCHED_VEHICLE_CHASSIS_FAILED';

// generalData
export const FETCHING_GENERAL_DATA_BY_CHASSIS = '@@toyota/FETCHING_GENERAL_DATA_BY_CHASSIS';
export const FETCHED_GENERAL_DATA_BY_CHASSIS = '@@toyota/FETCHED_GENERAL_DATA_BY_CHASSIS';
export const FETCHED_GENERAL_DATA_BY_CHASSIS_FAILED = '@@toyota/FETCHED_GENERAL_DATA_BY_CHASSIS_FAILED';

// inputData
export const FETCHING_INPUT_DATA_BY_CHASSIS = '@@toyota/FETCHING_INPUT_DATA_BY_CHASSIS';
export const FETCHED_INPUT_DATA_BY_CHASSIS = '@@toyota/FETCHED_INPUT_DATA_BY_CHASSIS';
export const FETCHED_INPUT_DATA_BY_CHASSIS_FAILED = '@@toyota/FETCHED_INPUT_DATA_BY_CHASSIS_FAILED';

// outputData
export const FETCHING_OUTPUT_DATA_BY_CHASSIS = '@@toyota/FETCHING_OUTPUT_DATA_BY_CHASSIS';
export const FETCHED_OUTPUT_DATA_BY_CHASSIS = '@@toyota/FETCHED_OUTPUT_DATA_BY_CHASSIS';
export const FETCHED_OUTPUT_DATA_BY_CHASSIS_FAILED = '@@toyota/FETCHED_OUTPUT_DATA_BY_CHASSIS_FAILED';
